import gql from 'graphql-tag';

export const QUERY_PARTNER_PAYOUT = gql`
  query CMS_Partner_Payout_Lists(
    $bookingIds: [ID]
    $bookingReferenceIds: [String]
    $partnerIds: [ID]
    $pageSize: PositiveInteger
    $pageNumber: PositiveInteger
    $partnerCodes: [String]
    $stages: [PartnerPayoutRecordStage]
    $statuses: [PartnerPayoutRecordStatus]
    $secondaryStatuses: [PartnerPayoutRecordSecondaryStatus]
    $updatedAtMax: Datetime
    $updatedAtMin: Datetime
    $sortBy: partnerPayoutRecordSortBy
    $sortDirection: SortDirection
    $currencies: [String]
    $countryIds: [ID]
    $paymentPreference: PaymentPreference
  ) {
    listPartnerPayoutRecords(
      pageSize: $pageSize
      pageNumber: $pageNumber
      sortBy: $sortBy
      sortDirection: $sortDirection
      bookingIds: $bookingIds
      bookingReferenceIds: $bookingReferenceIds
      partnerIds: $partnerIds
      partnerCodes: $partnerCodes
      stages: $stages
      statuses: $statuses
      secondaryStatuses: $secondaryStatuses
      updatedAtMax: $updatedAtMax
      updatedAtMin: $updatedAtMin
      currencies: $currencies
      countryIds: $countryIds
      paymentPreference: $paymentPreference
    ) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          partnerId
          partner {
            name
            code
          }
          bookingId
          bookingJourney
          bookingReferenceId
          simpleOpportunity {
            id
            referenceId
            updatedAt
            createdAt
          }
          countryId
          country {
            name
          }
          referrer {
            firstName
            lastName
          }
          status
          secondaryStatus
          cancelReason
          stage
          updatedAt
          createdAt
          amount
          currency
          version
          paymentPreference
        }
      }
    }
  }
`;

export const QUERY_SEARCH_PARTNER_CONTACTS = gql`
  query CMS_Partner_Contacts($pageSize: Int, $pageNumber: Int, $partnerName: NonEmptyString) {
    partnerContacts(pageSize: $pageSize, pageNumber: $pageNumber, partnerName: $partnerName) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          partner {
            name
            id
          }
        }
      }
    }
  }
`;

export const QUERY_OPPS_DETAIL = gql`
  query CMS_Partner_Payout_Lists($bookingIds: [ID], $bookingReferenceIds: [String]) {
    listPartnerPayoutRecords(bookingIds: $bookingIds, bookingReferenceIds: $bookingReferenceIds) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          partnerId
          partner {
            name
            code
          }
          bookingId
          bookingJourney
          leaseType
          simpleOpportunity {
            id
            referenceId
            createdAt
            updatedAt
            contacts {
              name
              email
            }
            partnerActualCommission {
              status
              amount
              currency
            }
            xbookings(interested: true) {
              edges {
                node {
                  city {
                    name
                    country {
                      name
                    }
                  }
                  student {
                    firstName
                    lastName
                    passportFirstName
                    passportLastName
                    passportMiddleName
                    emailAddress
                    currentUniversity
                    phoneNumber
                  }
                }
              }
            }
          }
          order {
            city {
              name
              country {
                name
              }
            }
            student {
              firstName
              lastName
              passportFirstName
              passportLastName
              passportMiddleName
              emailAddress
              currentUniversity
              phoneNumber
            }
            partnerActualCommission {
              status
              amount
              currency
            }
            createdAt
            updatedAt
          }
          countryId
          country {
            name
          }
          status
          stage
          updatedAt
          createdAt
          amount
          currency
        }
      }
    }
  }
`;

export const QUERY_SETTLEMENT_INFO = gql`
  query CMS_Get_Company_Wallet_Balance(
    $currency: String!
    $countryId: ID!
    $paymentPreference: PaymentPreference
  ) {
    getCompanyWalletBalance(
      currency: $currency
      countryId: $countryId
      paymentPreference: $paymentPreference
    ) {
      id
      currency
      budgetAmount
      approvedTotalAmount
      remainingAmount
      approvedPercentage
      nextSettleData
    }
  }
`;

export const QUERY_BALANCE_COUNTRY_CURRENCIES = gql`
  query CMS_Get_Balance_Country_Currencies {
    getBalanceCountryCurrencies {
      balanceCountryCurrencies {
        country {
          name
          countryCode
        }
        countryId
        currency
      }
    }
  }
`;

export const MUTATION_AUDIT_PAYOUT = gql`
  mutation bulkAuditPartnerPayoutRecords(
    $ids: [ID!]!
    $operationType: PartnerPayoutRecordOperationType!
  ) {
    bulkAuditPartnerPayoutRecords(input: { ids: $ids, operationType: $operationType }) {
      result
    }
  }
`;

export const MUTATION_SYNC_XHJ_TOPOP = gql`
  mutation syncXhjTopop {
    syncXhjTopop {
      result
    }
  }
`;

export const MUTATION_CANCEL_PAYOUT = gql`
  mutation cancelPayout(
    $bookingId: ID!
    $cancelReason: NonEmptyString!
    $deduct: Boolean!
    $secondaryStatus: PartnerPayoutRecordSecondaryStatus
    $bookingJourney: BookingJourney
  ) {
    cancelPayout(
      bookingId: $bookingId
      cancelReason: $cancelReason
      deduct: $deduct
      secondaryStatus: $secondaryStatus
      bookingJourney: $bookingJourney
    ) {
      result
    }
  }
`;

export const QUERY_COUNTRY = gql`
  query country($pageSize: Int, $pageNumber: Int, $countrySlugs: [String]) {
    countries(pageNumber: $pageNumber, pageSize: $pageSize, countrySlugs: $countrySlugs) {
      edges {
        node {
          name
          id
          countryCode
          currencyCode
          slug
          partnerCommissionCalculation {
            calculationPeriodStart
            calculationPeriodEnd
            leaseThresholdValue
            leaseThresholdUnit
            paymentCurrency
          }
        }
      }
    }
  }
`;

export const MUTATION_MANUALLY_SETTLE_PAYOUT = gql`
  mutation bulkSettlePartnerPayout(
    $payoutRecordIds: [ID!]!
    $paymentPreference: PaymentPreference!
  ) {
    bulkSettlePartnerPayout(
      input: { payoutRecordIds: $payoutRecordIds, paymentPreference: $paymentPreference }
    ) {
      result
    }
  }
`;
